import {createContext, type ReactNode, useContext} from 'react'

// `canEdit` covers job and project details, `canDispatch` crew, equipment and time entries.
export type EditRights = {canEdit: boolean; canDispatch: boolean}

const EditRightsContext = createContext<EditRights | null>(null)

export function EditRightsProvider({rights, children}: {rights: EditRights; children: ReactNode}) {
    return <EditRightsContext.Provider value={rights}>{children}</EditRightsContext.Provider>
}

export function useEditRights(): EditRights {
    const rights = useContext(EditRightsContext)
    if (!rights) {
        throw new Error('useEditRights must be used within an EditRightsProvider')
    }
    return rights
}
